import { PropertyTabId } from '../view-area/components/property-tabs/property-tabs.component';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ViewAreaComponent } from '../view-area/view-area.component';

@Component({
  selector: 'app-mobile-view',
  standalone: true,
  imports: [ViewAreaComponent],
  templateUrl: './mobile-view.component.html',
  styleUrl: './mobile-view.component.scss'
})
export class MobileViewComponent {
  @Input() selectedItem: any;
  @Input() activeTab: PropertyTabId = 'property';
  @Output() activeTabChange = new EventEmitter<PropertyTabId>();
  @Output() onClose = new EventEmitter<void>();
  @Output() lightboxOpen = new EventEmitter<number>();

  closeMobileView() {
    this.onClose.emit();
  }
}
